import CompoundCoursePart from "@/models/CompoundCoursePart";
import CourseRun from "@/models/CourseRun";
import LiveCourseParticipant from "@/models/LiveCourseParticipant";

export default class BuyCourseParticipant {
  constructor(raw = {}) {
    this.firstName = raw.firstName; //: String,
    this.lastName = raw.lastName; //: String,
    this.birthdate = raw.birthdate; //: OffsetDateTime? = null,
    this.email = raw.email; //: String,
    this.invoiceDeliveryEmail = raw.invoiceDeliveryEmail;
    this.orderId = raw.orderId; //: String,
    this.invoiceAddress = raw.invoiceAddress; //: String,
    this.invoicePhone = raw.invoicePhone;
    this.comment = raw.comment;
    this.wantsToBorrowBooks = raw.wantsToBorrowBooks; //: Boolean = false,
    this.borrowBooksAddress = raw.borrowBooksAddress; //: String? = null,
    this.attachments = raw.attachments; //: List<String> = emptyList(),
    this.confirmed = raw.confirmed; //: Boolean = false,
    this.fetchAgainPassword = raw.fetchAgainPassword; //: String,
    this.state = raw.state; //: BuyCourseParticipantState = BuyCourseParticipantState.WAITING
    this.lastAssessmentDate = raw.lastAssessmentDate;
    this.id = raw.id;
  }
}
